import Rating from './rating';
import './styles/index.scss';
export default Rating;
